module.exports = __webpack_public_path__ + "static/img/bg-fr.a5b1cf7f.webp";